<template>
  <table class="w-100">
    <template v-for="field in schema">
      <template v-if="typeof value[field.name] !== 'undefined'">
        <tr :key="field.uuid" v-if="[availableFields.text, availableFields.integer].includes(field.type)">
          <td>{{ field.title }}</td>
          <td>{{ value[field.name] }}</td>
        </tr>

        <tr :key="field.uuid" v-if="field.type === availableFields.textarea">
          <td>{{ field.title }}:</td>
          <td v-html="(value[field.name] || 'Не заполнено').replace(/\n/g, '<br>')"></td>
        </tr>

        <tr :key="field.uuid" v-if="field.type === availableFields.radio">
          <td>{{ field.title }}</td>
          <td>
            {{
              Array.isArray(field.options) && field.options.length > 0
                ? field.options.find(el => {
                    return el.value === value[field.name];
                  }).label
                : "Для поля не заполнены варианты значений в админ панели. Обратитесь к администрации."
            }}
          </td>
        </tr>

        <tr :key="field.uuid" v-if="field.type === availableFields.select">
          <td>{{ field.title }}</td>
          <td>{{ value[field.name + "_display_value"] }}</td>
          <!--
          <td>
            {{
              Array.isArray(field.options) && field.options.length > 0
                ? value[field.name]
                : "Для поля не заполнены варианты значений в админ панели. Обратитесь к администрации."
            }}
          </td>
          -->
        </tr>

        <tr :key="field.uuid" v-if="field.type === availableFields.datePicker">
          <td>{{ field.title }}</td>
          <td>{{ value[field.name] }}</td>
        </tr>

        <tr :key="field.uuid" v-if="field.type === availableFields.source">
          <td>{{ field.title }}</td>
          <td>
            <div v-if="value[field.name + '_display_value']">
              {{ formatSourceDisplayValue(value[field.name + "_display_value"]) }}
            </div>
            <div v-else-if="value[field.name] && Array.isArray(value[field.name]) && value[field.name].length">
              <div v-for="kitem in field.items" :key="kitem.id">
                <span v-if="value[field.name].includes(kitem.id)">{{ kitem.title }}</span>
              </div>
            </div>
            <div v-else-if="field.addedItems && field.addedItems.length">
              {{ field.addedItems.map(el => el.title).join(", ") }}
            </div>
            <div v-else-if="isFormattableSourceValue(value[field.name])">
              {{ formatSourceDisplayValue(value[field.name]) }}
            </div>
            <div v-else>Нет</div>
          </td>
        </tr>

        <tr v-if="field.type === availableFields.param" :key="field.uuid">
          <td>{{ field.title }}</td>
          <td>
            <template v-if="value[field.name]">{{ value[field.name] }} {{ field.options.measure_name }}</template>
            <template v-else>Не заполнено</template>
          </td>
        </tr>

        <tr v-if="field.type === availableFields.params" :key="field.uuid" class="mt-5">
          <td colspan="2">
            <div>
              <div class="d-flex align-items-center justify-content-between">
                <h4 class="card-title fw-100">Параметры</h4>
              </div>
            </div>
            <table v-if="Array.isArray(value[field.name]) && value[field.name].length" class="mt-3 w-100">
              <thead>
                <tr class="border-b border-bg_separator">
                  <th class="text-left p-1 pl-0 text-sm">Название параметра</th>
                  <th class="text-left p-1 text-sm">Значение</th>
                  <th class="text-left p-1 text-sm">Норма</th>
                </tr>
              </thead>
              <tbody class="p2">
                <tr v-for="item in value[field.name]" :key="item.uuid" class="border-b border-bg_separator p-1">
                  <td title="Параметр" class="p-1 pl-0">
                    <div>{{ item.param.name }}</div>
                  </td>
                  <td title="Количество" width="100px" class="p-1">
                    <div>{{ item.value }} {{ item.measure.name }}</div>
                  </td>
                  <td :title="item.edit ? 'Единица измерения' : 'Норма'" class="p-1">
                    <MedParamNorm :value="item.value" :min="item.measure.min" :max="item.measure.max" />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr v-if="field.type === availableFields.paramnorms" :key="field.uuid">
          <td colspan="2">
            <h4 class="card-title font-weight-light">Индивидуальные нормы параметров</h4>
            <v-simple-table dense v-if="Array.isArray(value[field.name]) && value[field.name].length">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Название параметра</th>
                    <th class="text-left">Минимум</th>
                    <th class="text-left">Максимум</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in value[field.name]" :key="item.uuid">
                    <td title="Параметр">
                      {{ item.param.name }}
                    </td>
                    <td title="Минимум" width="100px">
                      {{ item.min_value }}
                    </td>
                    <td title="Максимум" width="100px">
                      {{ item.max_value }}
                    </td>
                    <td :title="item.edit ? 'Единица измерения' : 'Норма'">
                      {{ item.measure.name }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
        </tr>
        <tr v-if="field.type === availableFields.bool" :key="field.uuid">
          <td>{{ field.title }}</td>
          <td>{{ value[field.name] === null ? "Не выбрано" : value[field.name] ? "Да" : "Нет" }}</td>
        </tr>
      </template>
    </template>
  </table>
</template>
<script>
import MedParamNorm from "@/components/MedParamNorm.vue";
import { DOCUMENT_AVAILABLE_FIELDS } from "@/modules/documents/add-document/document-available-fields.js";
// import { v4 } from "uuid";

export default {
  name: "DynamicPrintForm",
  components: { MedParamNorm },
  props: {
    schema: {
      type: Array,
      required: true,
    },
    patientId: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      errorMessages: {},
      dynamicForm: {},
      formFields: [],
      availableFields: DOCUMENT_AVAILABLE_FIELDS,
    };
  },
  methods: {
    isFormattableSourceValue(val) {
      if (!val) return false;
      if (Array.isArray(val) && val.length) return true;
      if (typeof val === "string" && val.trim().startsWith("[")) return true;
      return false;
    },
    formatSourceDisplayValue(val) {
      if (!val) return "";
      if (Array.isArray(val)) {
        return val
          .map(item => {
            if (typeof item === "object" && item.title) {
              return item.title;
            }
            return String(item);
          })
          .join(", ");
      }
      if (typeof val === "string" && val.trim().startsWith("[")) {
        try {
          const parsed = JSON.parse(val);
          if (Array.isArray(parsed) && parsed.length) {
            return this.formatSourceDisplayValue(parsed);
          }
        } catch (e) {
          // JSON parse failed, return original value
        }
      }
      return val;
    },
  },
};
</script>
<style scoped>
.w-100 {
  width: 100%;
}
</style>
